// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"styles_pageContent__YcVkO","withoutMarginTop":"styles_withoutMarginTop__KaGCG","withoutMarginBottom":"styles_withoutMarginBottom__8NRKU"};